import React from 'react';

const SuperAdminDashboard = () => (
  <h2>Welcome to SuperAdminDashboard Dashboard</h2>
);

export default SuperAdminDashboard;